import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export interface ServiceStatus {
  status: 'operational' | 'degraded' | 'down';
  connections?: number;
}

export interface HealthResponse {
  status: 'ok' | 'degraded' | 'outage';
  timestamp: string;
  services: {
    api: ServiceStatus;
    database: ServiceStatus;
    websocket: ServiceStatus;
  };
}

const HEALTH_URL = import.meta.env.PROD
  ? (import.meta.env.VITE_HEALTH_URL || 'https://health.hooklink.net')
  : '';

export function useSystemStatus(pollInterval = 30000) {
  return useQuery({
    queryKey: ['system-status'],
    queryFn: async () => {
      const { data } = await axios.get<HealthResponse>(`${HEALTH_URL}/health`);
      if (!data?.services) throw new Error('Invalid health response');
      return data;
    },
    refetchInterval: pollInterval,
    retry: 1,
  });
}
